// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3_z-s","footer":"ReportModalFilter_footer__2P_ja"};